import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `Ensure that the most up-to-date technology is used in the building 
    and maintenance of your website, which will increase the likelihood of your 
    company's success. My aim is to create a site that strengthens your company's 
    identity while also ensuring your audience's ease of use and simplicity.`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "Full-Stack Developer",
    text: `I manage the application's front-end and back-end to streamline and 
    expedite delivery by knowing what to expect at each step and being in a 
    better position to resolve any issues that arise, giving your web/app project
     the competitive edge it needs to thrive in the marketplace.`,
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title: "app design",
    text: `I design mobile applications that boost your company's brand while 
    also assisting with new customer acquisition.Mobile applications will unlock 
    the power of a better relationship with clients by driving high levels of engagement.`,
  },
]
